<template>
  <v-row no-gutters>
    <v-col
      cols="2"
      md="1"
      lg="1"
      align-self="center"
      class="text-center"
    >
      Set {{ number }}
    </v-col>
    <v-col
      cols="10"
      md="11"
      lg="11"
    >
      <div>
        <universal-input
          v-model="lbsKgs"
          :config="lbsKgsConfig"
        />
      </div>
      <div>
        <universal-input
          v-model="qty"
          :config="qtyConfig"
        />
      </div>
    </v-col>
  </v-row>
</template>
<script setup>
import { onMounted, ref, toRefs, watch } from 'vue'
import UniversalInput from '@/components/CRUD/UniversalInput.vue'

const prop = defineProps({
  number: {
    type: Number,
    required: true,
  },
  unit: {
    type: String,
    default: 'Times',
  },
  recordLbsKgs: {
    type: Number,
    default: 0,
  },
  recordQty: {
    type: Number,
    default: 0,
  },
  recordSetName: {
    type: String,
    default: '1',
  },
})
const { number, unit, recordLbsKgs, recordQty } = toRefs(prop)

const emits = defineEmits(['input'])

const lbsKgs = ref(0)
const lbsKgsConfig = ref({
  propName: 'lbsKgs',

  // label: 'lbs/Kgs',
  type: {
    name: 'slider',
    sliderCallback(value) {
      return `${value} lbs/Kgs`
    },
  },
})
const qty = ref(0)
const qtyConfig = ref({
  propName: 'lbsKgs',

  // label: 'lbs/Kgs',
  type: {
    name: 'slider',
    sliderCallback(value) {
      return `${value} ${unit.value}`
    },
  },
})

const setName = ref('1')
watch(lbsKgs, newVal => {
  console.log('lbsKgs', newVal)
  emits('input', {
    lbsKgs: newVal,
    qty: qty.value,
    setName: `${number.value}`,
  })
})
watch(qty, newVal => {
  console.log('qty', newVal)
  emits('input', {
    lbsKgs: lbsKgs.value,
    qty: newVal,
    setName: `${number.value}`,
  })
})
watch(recordLbsKgs, newVal => {
  // console.log('recordLbsKgs newVal', newVal)
  lbsKgs.value = newVal
})
watch(recordQty, newVal => {
  // console.log('recordQty newVal', newVal)
  qty.value = newVal
})
onMounted(() => {
  lbsKgs.value = recordLbsKgs.value
  qty.value = recordQty.value
  setName.value = `${number.value}`
})
</script>
